import { DonationCodingModel } from '@app/core/Models';

export class CreateDonationCoding {
  static readonly type = '[DONATIONCODING] Create Donation Coding';

  constructor(public donationCoding: DonationCodingModel) {}
}
